var map = {
	"./graphicArtiflex.png": 6192,
	"./graphicSTAAR.png": 4369,
	"./graphicSTAAR0.png": 2673,
	"./graphicSTAAR120.png": 566,
	"./graphicSTAAR150.png": 1847,
	"./graphicSTAAR30.png": 8271,
	"./graphicSTAAR60.png": 3684,
	"./graphicSTAAR90.png": 6818,
	"./graphicStandard.png": 1572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7668;